/**
 * Auth API - 登录 / 刷新 / 登出 / 取当前用户.
 *
 * 后端端点 (apps/backend/app/api/v1/auth.py + user.py):
 *   POST /auth/login    { phone, password }          -> TokenResponse
 *   POST /auth/refresh  { refresh_token }            -> TokenResponse
 *   POST /auth/logout?refresh_token=xxx  (Bearer)    -> 204   (注意 refresh_token 走 query)
 *   GET  /me            (Bearer)                      -> User
 */
import { http, setTokens, clearTokens, getRefreshToken } from './client'
import type {
  LoginRequest,
  RefreshRequest,
  TokenResponse,
  User,
  ChangePasswordRequest,
} from '@/types/api'

export async function login(payload: LoginRequest): Promise<TokenResponse> {
  const res = await http.post<TokenResponse>('/auth/login', payload)
  setTokens(res.data.access_token, res.data.refresh_token)
  return res.data
}

export async function refresh(payload: RefreshRequest): Promise<TokenResponse> {
  const res = await http.post<TokenResponse>('/auth/refresh', payload)
  setTokens(res.data.access_token, res.data.refresh_token)
  return res.data
}

export async function logout(): Promise<void> {
  const refreshToken = getRefreshToken()
  try {
    await http.post('/auth/logout', null, {
      params: refreshToken ? { refresh_token: refreshToken } : undefined,
    })
  } finally {
    clearTokens()
  }
}

export async function getMe(): Promise<User> {
  const res = await http.get<User>('/me')
  return res.data
}

export async function changePassword(payload: ChangePasswordRequest): Promise<void> {
  await http.post('/me/password', payload)
}
